module.exports = __webpack_public_path__ + "static/img/dev-2.e250c668.png";